import { useEffect, useState } from 'react'

export const useEditor = (pageContent: any) => {
  const [state, setState] = useState<any>(pageContent)

  useEffect(() => {
    if (window.storyblok) {
      window.storyblok.init()
      window.storyblok.on(['change', 'published'], () => location.reload(true))

      window.storyblok.on('input', ({ story }: any) => {
        if (story.content._uid === pageContent._uid) {
          setState(window.storyblok.addComments(story.content, story.id))
        }
      })
    } else {
      setState(pageContent)
    }
  }, [pageContent])

  return state
}
